import { useNavigate } from 'react-router-dom';
import { ButtonUI, DialogUI } from '../Interface';
import useParam from '../../context/ParamContext';
import useUsers from '../../context/UsersContext';

const MessagesDialog = ({ open, handleClose, messages, handleReadAtAll }) => {
  const { params } = useParam();
  const { user } = useUsers();
  const navigate = useNavigate();

  const handleNavigateTo = (navigateTo, formId) => {
    const formIds = params.EXCLUDE_FORM_MESSAGE_NAVIGATE ? JSON.parse(params.EXCLUDE_FORM_MESSAGE_NAVIGATE) : [];

    if (!formIds.includes(formId)) {
      navigate(`/app/${navigateTo}`);
      handleClose();
    }
  };

  const allowedRoleIds = params.ALLOWED_ROLEIDS_FOR_ACKNOWLEDGE
    ? JSON.parse(params.ALLOWED_ROLEIDS_FOR_ACKNOWLEDGE)
    : [];

  const canShowReadAllButton = allowedRoleIds.length === 0 || allowedRoleIds.includes(user.roleId);

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Üzenetek"
      closeBtn={true}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '900px',
          },
        },
      }}
    >
      <div>
        {canShowReadAllButton && (
          <ButtonUI
            className="bg-primary px-2 mt-2 mb-1"
            text="Mindet elolvastam"
            size="sm"
            onClick={() => handleReadAtAll()}
          />
        )}
        <table className="border w-full">
          <thead className="bg-[#BDE0FB]">
            <tr className="grid grid-cols-4">
              <th className="border p-3 col-span-3">Nézet</th>
              <th className="border p-3 col-span-1">Összesen</th>
            </tr>
          </thead>
          <tbody>
            {messages?.length > 0 ? (
              messages.map((message, index) => (
                <tr
                  key={message.formId}
                  className={`${index % 2 === 0 ? 'bg-gray-100' : ''} hover:bg-[#fff0b3] cursor-pointer grid grid-cols-4`}
                  onClick={() => handleNavigateTo(message.navigate, message.formId)}
                >
                  <td className="border p-2 col-span-3">{message.description ?? message.formName}</td>
                  <td className="border p-2 col-span-1">{message.count}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="border p-2 text-center col-span-1">Nincsenek üzenetek.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </DialogUI>
  );
};

export default MessagesDialog;
